import { persistCombineReducers } from 'redux-persist';
import domainDataReducer from './domainData';
import authReducer from './auth';
import { importPortfolioFromFileReducer } from '../../topic/Portfolio/reducers/reducers';

import appConfig from '../config/store';

import brokerFavReducers from '../../dalalstreet/src/redux/BrokerFavorites/BrokerActions';
import stockReducers from '../../dalalstreet/src/redux/StocksDetails/StocksDetails';
import hotStocks from '../../dalalstreet/src/redux/HotStocks/Actions';
import brokerConcentration from '../../dalalstreet/src/redux/BrokerConcentration/Actions';
import netHoldings from '../../dalalstreet/src/redux/NetHoldings/Actions';

const appReducer = persistCombineReducers(
    appConfig,
    {
        domainData: domainDataReducer,
        auth: authReducer,
        importPortfolio: importPortfolioFromFileReducer,
        brokerFavorites: brokerFavReducers,
        stockDetails: stockReducers,
        hotStocks,
        brokerConcentration,
        netHoldings,
    },
);


export default appReducer;



// WEBPACK FOOTER //
// ./src/common/reducers/index.js